import { DELETE, GET, POST } from '../../common/common.service'
import endpointsNotifications from './endpoints'

export const NotificationsService = {
  getAllModuleUsers: async ({ filter, sort, limit, skip }) =>
    GET(endpointsNotifications.LOAD(filter, sort, limit, skip)),
  addUser: async (id, body) => POST(endpointsNotifications.ADD(id), body),
  removeUser: async (id, userId) =>
    DELETE(endpointsNotifications.REMOVE(id, userId)),
}
